// API configuration for the frontend
// In production: use absolute URL to api.thehousekeepingkw.com
// In development: use localhost:3001

export const API_URL = import.meta.env.PROD
  ? 'https://api.thehousekeepingkw.com/api'
  : 'http://localhost:3001/api';

// Helper function to build full API URLs
export const buildApiUrl = (path: string) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${cleanPath}`;
};
